import { BaseModel } from "../base.model";
import { DBFactory } from "classes/database/db_factory";

type LMSOrganizationConfigContrusctorParams = {
  id: string;
  provider: "sakai" | "google" | "canvas" | "iew";
};

export class LMSOrganizationConfig extends BaseModel {
  id: string;
  provider: "sakai" | "google" | "canvas" | "iew";

  constructor(data: LMSOrganizationConfigContrusctorParams) {
    super(data);

    this.id = data.id;
    this.provider = data.provider;
  }

  override get databaseConfig(): ModelDatabaseConfig {
    return {
      collection: "/lmsOrganizationConfigs",
      path: `/lmsOrganizationConfigs/${this.id}`,
    };
  }

  static override fromMap(map: any): LMSOrganizationConfig {
    switch (map.provider) {
      case "google":
        return new GoogleLMSOrganizationConfig(map);
      case "iew":
        return new IEWGradebookLMSOrganizationConfig(map);
      case "sakai":
      default:
        return new SakaiLMSOrganizationConfig(map);
    }
  }

  async save() {
    const db = DBFactory.createDatabase();
    await db.save(this.toMap(), this.databaseConfig);
  }
}

type SakaiLMSOrganizationConfigContrusctorParams = Omit<
  LMSOrganizationConfigContrusctorParams,
  "provider"
> & {
  config: {
    endpoint: string;
    username: string;
    password: string;
    soapEndpoint: string;
  };
};

export class SakaiLMSOrganizationConfig extends LMSOrganizationConfig {
  config: {
    endpoint: string;
    username: string;
    password: string;
    soapEndpoint: string;
  };

  constructor(data: SakaiLMSOrganizationConfigContrusctorParams) {
    super({
      ...data,
      provider: "sakai",
    });

    this.config = data.config;
  }
}

type GoogleLMSOrganizationConfigContrusctorParams = Omit<
  LMSOrganizationConfigContrusctorParams,
  "provider"
> & {};

export class GoogleLMSOrganizationConfig extends LMSOrganizationConfig {
  constructor(data: GoogleLMSOrganizationConfigContrusctorParams) {
    super({
      ...data,
      provider: "google",
    });
  }
}

type IEWGradebookLMSOrganizationConfigContrusctorParams = Omit<
  LMSOrganizationConfigContrusctorParams,
  "provider"
>;

export class IEWGradebookLMSOrganizationConfig extends LMSOrganizationConfig {
  constructor(data: IEWGradebookLMSOrganizationConfigContrusctorParams) {
    super({
      ...data,
      provider: "iew",
    });
  }
}
